import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ApiConfiguration } from '@api/api-configuration';
import { BaseService, Customer, SaveCustomerRequest } from '@api/index';
import { IdName } from '@api/models/idname';
import { PaginationResult } from '@api/models/paginator';
import { PricingDetails } from '@api/models/pricing';
import { StorageLimitsResponse } from '@api/models/storage-limits';

@Injectable({
  providedIn: 'root',
})
export class CustomerApi extends BaseService {
  private baseUrl = `${this.rootUrl}/customers`;

  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  getCustomers(): Observable<Customer[]> {
    return this.http.get<Customer[]>(`${this.baseUrl}`);
  }

  getCustomersList(params?: any): Observable<PaginationResult<Customer>> {
    return this.http.get<PaginationResult<Customer>>(`${this.baseUrl}/customers-list`, { params });
  }

  getCustomerOptions(countries?: string[]): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.baseUrl}/options`, { params: { ...(countries && { countries }) } });
  }

  getCustomerById(id: number): Observable<any> {
    return this.http.get<Customer>(`${this.baseUrl}/${id}`);
  }

  saveCustomer(request: SaveCustomerRequest): Observable<Customer> {
    return this.http.post<Customer>(`${this.baseUrl}`, request);
  }

  removeCustomer(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  // GET /Customers/price-details
  getMediaPriceDetails(customerId: number[]): Observable<PricingDetails> {
    return this.http.get<PricingDetails>(`${this.baseUrl}/price-details`, { params: { customerId } });
  }

  // GET /Customers/storage-limit-details
  getStorageLimitDetails(customerId?: number): Observable<StorageLimitsResponse> {
    return this.http.get<StorageLimitsResponse>(`${this.baseUrl}/storage-limit-details`, { params: { customerId } });
  }
}
